import "../../Styles/General & MultiUse/SuccessFailure.css";
import Success from "../../Assets/Success.png";
import Failure from "../../Assets/Failure.png";
import Cancel from "../../Assets/Cancel.png";
import { useLocation, useNavigate } from "react-router-dom";
import { ZGAContext } from "../../ZGAContext";
import { useContext, useEffect } from "react";
import ReactDOM from "react-dom";

const SuccessFailure = () => {
  const { successModal, hideSuccessModal, showSuccessModal } = useContext(ZGAContext);
  const { isVisible, message, isSuccess, actionPath, pathText } = successModal;
  const navigate = useNavigate();
  const location = useLocation();

  const isForgotPasswordRoute = location.pathname === "/auth/forgotPassword";

  const handleAction = () => {
    if (actionPath) {
      navigate(actionPath);
    }
    hideSuccessModal();
  };

  const handleCancel = () => {
    hideSuccessModal();

    if (isForgotPasswordRoute) {
      navigate("/auth/login");
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      if (showSuccessModal) {
        hideSuccessModal();
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [showSuccessModal, hideSuccessModal]);

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop" onClick={hideSuccessModal}></div>
      <div className="successFailure">
        {(isForgotPasswordRoute || !isSuccess) && (
          <img className="cancel" src={Cancel} alt="Cancel" onClick={handleCancel} />
        )}
        <img className="sfImage" src={isSuccess ? Success : Failure} alt="" />
        <p>{message}</p>
        {isSuccess && !isForgotPasswordRoute && <button onClick={handleAction}>Proceed to {pathText}</button>}
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default SuccessFailure;
